/**
 * State Snapshot System
 *
 * Captures and restores full editor state for undo/redo and presets.
 * Combines Fabric.js canvas objects with editor metadata (scheme,
 * overlays, template, size) into a single serializable object.
 */

import { fabricToState } from './design-state.js';

/**
 * Capture a complete snapshot of the current editor state.
 *
 * @param {fabric.Canvas} canvas - the Fabric.js canvas instance
 * @param {object} editorState - currentState from app.js
 * @param {string} size - current output size key
 * @param {number} [mangleSeed=0] - current mangle seed
 * @returns {object} Serializable state snapshot
 */
export function captureSnapshot(canvas, editorState, size, mangleSeed = 0, extras = {}) {
  return {
    template: editorState.template,
    size,
    scheme: { ...editorState.scheme },
    objects: fabricToState(canvas),
    overlays: JSON.parse(JSON.stringify(editorState.overlays)),
    watermark: editorState.watermark,
    eventDateISO: editorState.eventDateISO || '',
    blendLayers: editorState.blendLayers ? JSON.parse(JSON.stringify(editorState.blendLayers)) : [],
    mangleSeed,
    // Wordmark settings
    wordmark: extras.wordmark || null,
    // Mangle params
    mangleParams: extras.mangleParams || null,
    // User-created text objects
    userTextObjects: extras.userTextObjects || [],
  };
}
